export default __webpack_public_path__ + "static/media/Teleport Icon.062cba09.svg";